<template>
  <div>
    <div
      v-if="getPlanDetailsLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting Plan Profile ready...</h3>
        </div>
      </div>
    </div>
    <div class="rider--main-content" v-else-if="planDetails !== null">
      <router-link :to="{ name: 'Target Plan' }" class="arrow_text">
        <chevron-left-icon
          size="1.5x"
          class="custom-class"
          style="vertical-align: top;"
        ></chevron-left-icon>
        <span class="back">Back</span>
      </router-link>
      <h1 class="mt-2 mb-3 font-regular">
        Plan Profile&nbsp;&nbsp; for
        <span style="color: #32417E;">{{ slug }}</span>
        from
        {{ planDetails.customer.name }}
      </h1>
      <div class="row mb-5">
        <div class="col-lg-12">
          <CScrollbar
            class="nav nav-tabs nav-overflow header-tabs"
            :settings="psSettings"
            tag="ul"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']"
              >
                Plan Details
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']"
              >
                Payment Frequency / Source
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="javascript:void(0)"
                v-on:click="activetab = 3"
                v-bind:class="[activetab === 3 ? 'active' : '']"
              >
                Logs
              </a>
            </li>
          </CScrollbar>
        </div>
      </div>

      <!-- tabs plan readables and  -->
      <div class="row" v-if="activetab === 1">
        <div class="col-md-6 mb-3">
          <!-- Transaction Summary -->
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Payment Details</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div
                  class="transaction-details"
                  v-for="(readable, index) in planDetails.readable"
                  :key="index"
                >
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        {{ readable.label }}
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6 v-html="readable.value" class="text-blue fw-400"></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Customer Summary</h3>
            </div>
            <div class="card-content text-center">
              <div
                class="card-body row align-items-center justify-content-center"
              >
                <div class="col-12">
                  <h4>
                    <span class="fw-bold">Name:</span>
                    {{ planDetails.customer.name }}
                  </h4>

                  <h4>
                    <span class="fw-bold">Email:</span>
                    {{ planDetails.customer.email }}
                  </h4>
                  <h4>
                    <span class="fw-bold">Wallet Balance:</span>
                    &#8358;{{ planDetails.customer.wallet_balance }}
                  </h4>
                  <router-link
                    class="button"
                    :to="{
                      name: 'CustomerComponent',
                      params: { slug: planDetails.customer_id }
                    }"
                  >
                    View Profile
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- tabs plan readables and  -->
      <div class="row" v-if="activetab === 2">
        <div class="col-md-6 mb-3">
          <!-- Transaction Summary -->
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Frequency Details</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div class="transaction-details">
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        Frequency
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6
                        v-html="planDetails.frequency"
                        class="text-blue fw-400"
                      ></h6>
                    </div>
                  </div>
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        Frequency Amount
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6
                        v-html="planDetails.frequency_amount"
                        class="text-blue fw-400"
                      ></h6>
                    </div>
                  </div>
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        Frequency Data
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6
                        v-html="planDetails.frequency_data"
                        class="text-blue fw-400"
                      ></h6>
                    </div>
                  </div>
                  <div
                    class="row align-items-center justify-content-between mt-1"
                  >
                    <div class="col-auto">
                      <h5 class="text-blue fw-700 fw-bolder">
                        Frequency Debit time
                      </h5>
                    </div>
                    <div class="col-auto">
                      <h6
                        v-html="planDetails.frequency_debit_time"
                        class="text-blue fw-400"
                      ></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Card Details</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div
                  class="row align-items-center justify-content-between mt-1"
                >
                  <div class="col-auto">
                    <h5 class="text-blue fw-700 fw-bolder">
                      Expiry Date
                    </h5>
                  </div>
                  <div class="col-auto">
                    <h6
                      v-html="planDetails.pay_source.expiry_date"
                      class="text-blue fw-400"
                    ></h6>
                  </div>
                </div>
                <div
                  class="row align-items-center justify-content-between mt-1"
                >
                  <div class="col-auto">
                    <h5 class="text-blue fw-700 fw-bolder">
                      Mask Pan
                    </h5>
                  </div>
                  <div class="col-auto">
                    <h6
                      v-html="planDetails.pay_source.mask_pan"
                      class="text-blue fw-400"
                    ></h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- logs -->
      <div class="row" v-if="activetab === 3">
        <div class="col-md-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <CDataTable
                  :items="logs"
                  :fields="fields"
                  :items-per-page="small ? 10 : 5"
                  pagination
                  sorter
                  tableFilter
                  itemsPerPageSelect
                >
                  <template #created_at="{item}">
                    <td class="table--action-mobile">
                      {{ item.created_at | date }}
                    </td>
                  </template>
                </CDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
// import ErrorService from "@/services/error.service";
// import Swal from "sweetalert2";
import { ChevronLeftIcon } from "vue-feather-icons";
import CScrollbar from "@/components/CScrollbar";
// import CCard from "@/components/CCard";
import CPagination from "@/components/CPagination.vue";
import CDataTable from "@/components/CDataTable.vue";
import { CameraIcon } from "vue-feather-icons";

const fields = [
  "debit_amount",
  "debit_time",
  "no_of_trails",
  "payment_method",
  "status",
  "created_at"
];
export default {
  name: "TargetPlanComponent",
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    ChevronLeftIcon,
    CScrollbar,
    CDataTable,
    // CCard,
    CPagination,
    "camera-icon": CameraIcon
  },
  computed: {
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    }
  },
  data() {
    return {
      getPlanDetailsLoading: false,
      planDetails: null,
      small: false,
      logs: [],
      fields,
      activetab: 1
    };
  },
  methods: {
    async getPlanDetails() {
      try {
        this.getPlanDetailsLoading = true;
        const response = await ApiService.get(
          `backend/savings/get-single-target-save-plan/${this.slug}`
        );
        this.planDetails = response.data.data;
        this.logs = this.planDetails.logs;
        this.getPlanDetailsLoading = false;
      } catch (error) {
        this.getPlanDetailsLoading = false;
        console.log(error.response);
      }
    }
  },
  mounted() {
    this.getPlanDetails();
  }
};
</script>

<style scoped></style>
